import { THEME } from '@HoudiniUI/Theme/theme';
import { SPACE } from '@Theme';
import { StyleSheet } from 'aphrodite';
import { label, titles } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
	},
	content: {
		height: `calc(100% - 56px)`,
		width: '100%',
	},
	header: {
		color: titles,
		display: 'flex',
		width: '100%',
	},
	// The same help-box treatment as the shared mailbox note, so it reads as a modifier, not another recipient group.
	includeGuests: {
		backgroundColor: THEME.colors.background.main,
		borderRadius: THEME.common.borderRadius,
		// Flush with the status checkboxes above; a negative margin here gets clipped by the composer panel.
		marginTop: SPACE[24],
		padding: SPACE[12],
		paddingLeft: SPACE[8],
	},
	includeGuestsLabel: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.xs,
		lineHeight: 1.4,
	},
	infoPopoverAnchor: {
		paddingLeft: SPACE[8],
	},
	infoPopoverContent: {
		color: label,
		fontSize: 14,
		padding: '0px 8px',
		width: 260,
	},
});
